<script>
import Loader from '@/components/widgets/loader';
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    valueTitle: {
      type: [String, Number],
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    component: {
      type: Object,
      default: undefined
    }
  },
};
</script>

<template>
  <Loader :loading="loading">
    <div class="card mini-stats-wid border-0" style="padding: 12px; height: 89px">
      <div class="card-body p-0">
        <div class="">
          <div class="">
            <p class="stat-title m-0">{{title}}</p>
            <div class="d-flex align-items-end gap-1">
              <span class="mb-1" style="font-size: 14px;line-height:17px;font-weight:500;letter-spacing:0.02rem;color:#6c7589">Rp</span>
              <div style="font-size: 24px; line-height:28.8px;font-weight:800;letter-spacing:0.02rem;color:#161B4D" class="mb-0" >{{value}}</div>
            </div>
            <div style="font-size: 10px;line-height:17px;font-weight:500;letter-spacing:0.02rem;color:#6c7589" class="mb-0" >{{ $moment().format('dddd, D MMMM YYYY') }}</div>
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>


<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    right: 20px !important;
    background-color: rgba(255,255,255,0.5);
  }
  .status {
    left: 90%;
    right: 10%;
    .spinner-chase {
      width: 24px;
      height: 24px;
      margin: 8px;
    }
  }
}
.mini-stats-wid {
  .media-body {
    p {
      font-weight: 500;
      font-size: 14px;
      color: #6C7589 !important;
    }

    h4 {
      font-weight: 800;
      font-size: 18px;
      color: #161B4D;
    }
  }
}

.stat-title {
  font-weight: 500;
  font-size: 14px;
  color: #6C7589 !important;
}

.stat-value {
  font-weight: 800;
  font-size: 18px;
  line-height: 43px;
  letter-spacing: 0.02em;
  color: #161B4D;
}
</style>